import { render } from "./view.vue?vue&type=template&id=3a5c52e4"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=3a5c52e4&lang=scss"
script.render = render

export default script